export default [
    {
        path: 'parametrizacao',
        component: () => import(
            /* webpackChunkName: 'exame-imagem-parametrizacao' */
            '@/views/exame-imagem/parametrizacao/Index'
        ),
        redirect: 'parametrizacao/create',
        children: [
            {
                name: 'exame-imagem-parametrizacao-create',
                path: 'create',
                component: () => import(
                    /* webpackChunkName: 'exame-imagem-parametrizacao' */
                    '@/views/exame-imagem/parametrizacao/Form.vue'),
            },
        ]
    }
]